export default __webpack_public_path__ + "static/media/register-slide-1.43faa1c8.jpg";